import { render, staticRenderFns } from "./ExtendedSkuTable.vue?vue&type=template&id=5f958cca&scoped=true"
import script from "./ExtendedSkuTable.vue?vue&type=script&lang=js"
export * from "./ExtendedSkuTable.vue?vue&type=script&lang=js"
import style0 from "./ExtendedSkuTable.vue?vue&type=style&index=0&id=5f958cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f958cca",
  null
  
)

export default component.exports